import { treePinSvg } from "./treePins";

const PIN_TYPES: [string, string][] = [["PALMEIRA", "Palmeira"], ["MUDA", "Muda"]];
import { TREE_PIN_STATES } from "@/config/tree-pin-states";

// Situacoes aplicadas no mapa, na ordem do catalogo (critico primeiro).
const legendStates = TREE_PIN_STATES.filter((s) => s.applied);

/** Legenda: cor do marcador = classe de risco da ultima avaliacao registrada. */
export default function MapLegend({ collapsed, onToggle }: { collapsed: boolean; onToggle: () => void }) {
  return (
    <div className={`bg-white/95 backdrop-blur-sm border border-background-200/70 rounded-card shadow-sm transition-all ${collapsed ? "w-10" : "w-52"}`}>
      <div className="flex items-center justify-between px-2.5 py-2">
        {!collapsed && <span className="text-[11px] font-semibold text-foreground-800 font-heading whitespace-nowrap">Legenda</span>}
        <button
          onClick={onToggle}
          className="w-6 h-6 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors shrink-0"
          title={collapsed ? "Expandir legenda" : "Recolher legenda"}
        >
          <i className={`text-foreground-500 text-sm ${collapsed ? "ri-arrow-left-s-line" : "ri-arrow-right-s-line"}`}></i>
        </button>
      </div>

      {!collapsed && (
        <div className="px-2.5 pb-2.5 space-y-1.5">
          {legendStates.map((item) => (
            <div key={item.code} className="flex items-center gap-2" title={item.rule}>
              <img src={item.icon} alt="" width={14} height={16} className="shrink-0" />
              <p className="text-[11px] font-medium text-foreground-800 leading-tight whitespace-nowrap">{item.label}</p>
            </div>
          ))}

          <div className="pt-1.5 border-t border-background-200/70 space-y-1">
            <div className="flex items-center gap-2">
              <span className="w-3.5 h-2.5 border-2 border-dashed inline-block" style={{ borderColor: "#1B6E4F" }}></span>
              <span className="text-[10px] text-foreground-600">Área piloto</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-3.5 h-2.5 border inline-block" style={{ borderColor: "#2563eb" }}></span>
              <span className="text-[10px] text-foreground-600">Quadras</span>
            </div>
          </div>

          <div className="pt-1.5 border-t border-background-200/70">
            <p className="text-[10px] text-foreground-500 mb-1">Outros tipos (cor = risco)</p>
            <div className="flex items-center gap-3 text-[10px] text-foreground-600">
              {PIN_TYPES.map(([tipo, label]) => (
                <span key={tipo} className="flex items-center gap-1 whitespace-nowrap">
                  <span dangerouslySetInnerHTML={{ __html: treePinSvg(tipo, "#6b7280", false, 13) }} /> {label}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
